import React from 'react';
import PropTypes from 'prop-types';
import Searcher from '../base/Searcher/Searcher';
import textTranslates from './translate.json';

const CompanySearchBox = (props) => {
    return(
        <Searcher
            title={textTranslates.companySearchBoxTitle}
            inputKeyPressed ={props.onSearchInputKeyPressed}
            inputTextChanged={props.onSearchInputTextChanged}
            inputType="text"
            inputPlaceholder={textTranslates.companySearchCompanyBoxPlaceholder}
            searchButtonClicked={props.onSearchButtonClicked}
            value={props.searchValue}/>
    );
};

CompanySearchBox.propTypes = {
    onSearchButtonClicked: PropTypes.func,
    onSearchInputKeyPressed: PropTypes.func,
    onSearchInputTextChanged: PropTypes.func,
    searchValue: PropTypes.string,
};

export default CompanySearchBox;


// WEBPACK FOOTER //
// ./src/components/Company/CompanySearchBox.js